import { render, staticRenderFns } from "./kv-markdown-editor.vue?vue&type=template&id=ed2466a2"
import script from "./kv-markdown-editor.vue?vue&type=script&lang=js"
export * from "./kv-markdown-editor.vue?vue&type=script&lang=js"
import style0 from "./kv-markdown-editor.vue?vue&type=style&index=0&id=ed2466a2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports